import React, { Component, useEffect, useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import Logo from './images/logo2-removebg-preview (1).png'
import dog from './images/dog.jfif'
import './css_files/profile.css'
import DogCard from './dog_card';
import Card from './card';
import Profile_Card from './profile_card';
import { useParams, useLocation, useNavigate } from "react-router-dom"
import axios from 'axios';
import { url } from '../weburl';


import Pedigree from './pedigree';
import { ProfileFooter } from './profile_footer';
import ProfileNav from './profile-nav';
import Footer from './footer';
import { useMediaQuery } from '@mui/material';
import { ProfileNavMobile } from './profile-nav-mobile';

// export default DogCard;
const card_style = {
    height: '100px',
    width: '100px,'
}
const { height, width } = card_style

export function withRouter(Child) {
    return (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        return <Child {...props} navigate={navigate} params={params} location={location} />;
    }

}

export const ProfileDog = (props) => {
    const [specificDog, setSpecificDog] = useState({})
    const [edit, setEdit] = useState(false)
    const [mobileView, setMobileView] = useState(false)
    const matches = useMediaQuery('(max-width:600px)');

    useEffect(()=> {
        props.getdogpedigree(props.params.dog_id)
        getspecificdog()
    }, [])

    useEffect(()=> {
        console.log('width changed')
        if (matches){
            setMobileView(true)
        }
        else{
            setMobileView(false)
        }
        
    }, [matches])

    const getspecificdog = () => {
        axios
            .get(`${url}api/dogs/${props.params.dog_id}`)
            .then((res) => {
                console.log(props.params.dog_id)
                setSpecificDog(res.data[0])
                      }
            )

            .catch((err) => {
                console.log("Error couldnt get Dog");
                console.log(err.message);
            });
    }

    const handleDelete = () => {
        axios
            .delete(`${url}api/dogs/${props.params.dog_id}`)
            .catch((err) => {
                console.log("Error couldnt delete Dog");
                console.log(err.message);
            });

    }


   return(
            <div className='profiledog '>
                    {mobileView ? <ProfileNavMobile color="white"/> : <ProfileNav color="white"/>}
               

                    <div className='row  align-items-start justify-content-start yellow py-5'>




                        <div className='col-md-12'>


                            {props.pedigree ? <Profile_Card image_src={Logo} height={height}
                                width={width}
                                dog={props.pedigree.maindog}
                                sire={props.pedigree.sire}
                                dam={props.pedigree.dam}

                            />
                                : null}
                        </div>


                    </div>



                {props.pedigree.maindog.name ?
                 <Pedigree data={props.pedigree}
                /> : null}

                    {/* profile at the bottom for mobile views */}
                    {/* {window.screen.width < 660 && <ProfileFooter navbarcolor='white'/>} */}
            

                <Footer/>
            </div>

        
   )

}







export default withRouter(ProfileDog);